import React from 'react'

const FStackOverflow = () => {
  return (
    <div className='footer-column-container'>
      <div className='footer-container-1 footer-heading'>
        <h3>STACK OVERFLOW</h3>
      </div>
      <div className='footer-container-1'>
        <p>Questions</p>
      </div>
      <div className='footer-container-1'>
        <p>Help</p>
      </div>
    </div>
  )
}

export default FStackOverflow